import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '@/contexts/AuthContext';
import { useLanguage } from '@/contexts/LanguageContext';
import { requestParams } from './RequestFilters';

const counters = [['permission_accepted', 'Permissions accepted', 'استئذانات مقبولة'], ['permission_rejected', 'Permissions rejected', 'استئذانات مرفوضة'], ['absence_accepted', 'Absences accepted', 'أعذار غياب مقبولة'], ['absence_rejected', 'Absences rejected', 'أعذار غياب مرفوضة']];
export const RequestStatistics = ({ employeeId, filters = {}, refreshKey, prefix = 'requests' }) => {
  const { token } = useAuth();
  const { isRTL } = useLanguage();
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const params = JSON.stringify(requestParams({ ...filters, employee_id: employeeId }));
  useEffect(() => {
    let active = true;
    setData(null);
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/request-tools/statistics`, { params: JSON.parse(params), headers: { Authorization: `Bearer ${token}` } })
      .then(r => { if (active) { setData(r.data); setError(''); } })
      .catch(() => { if (active) setError('Request statistics could not be loaded'); });
    return () => { active = false; };
  }, [token, params, refreshKey]);
  return <section className="border-y border-slate-200 py-5" data-testid={`${prefix}-statistics`} aria-live="polite">
    {error ? <p role="alert" data-testid={`${prefix}-statistics-error`} className="text-sm text-red-700">{error}</p> :
      <div className="grid grid-cols-2 gap-x-5 gap-y-6 lg:grid-cols-4">{counters.map(([key, en, ar]) =>
        <div key={key}><p className="text-xs text-slate-600">{isRTL ? ar : en}</p><p className="mt-2 text-2xl font-semibold tabular-nums" data-testid={`${prefix}-${key.replaceAll('_', '-')}`}>{data ? data[key] : '—'}</p></div>)}</div>}
  </section>;
};